export default "__VITE_ASSET__BRQtScCD__"